module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/widget-duplicados.c0706f91.svg";